/**
 * アカウント一覧カードの「受付/予約」ラベルの表示判定。
 *
 * 判定の実体はサーバ側（backend/adonis/app/Utils/PendingConsultationUtil.js）にあり、
 * 一覧 API が行ごとに has_pending_consultation(boolean) を返す。ここはその真偽値を
 * 読むだけで、条件をフロント側に持たない（事務局の絞り込み「受付/予約」と
 * 同じ画面に出るため、条件が 2 箇所にあると食い違う）。
 *
 * ⚠️ 既読フラグ・カードの開閉状態を判定に混ぜないこと。
 *    このラベルは「相談が進行中であること」を示すもので、担当者が開いたかどうかとは無関係。
 *    開いたら消える挙動は別機能（新着マークの既読制御）の領分。
 *
 * userState.js / corporateSchool.js と同じく、commonFunctions（catch-all・Vuex store からも
 * import される）の肥大を避けるための専用 mixin。純関数のみ（this 非依存・user は引数渡し）。
 */
export default {
  methods: {
    /**
     * 進行中（未完了）の健康相談を持つ利用者かを判定する純関数。
     * @param {{has_pending_consultation?: boolean}} user 一覧 API が返した行
     * @returns {boolean} 判定値が真なら true。値が無い・user 自体が無い場合は false
     */
    hasPendingConsultation(user) {
      return !!(user && user.has_pending_consultation);
    },
  },
};
